<template v-if="hasTier2Link || hasTier3Link">
  <nav
    class="breadcrumbs"
    :aria-label="$string('general.breadcrumbs.accessibility.aria_label')"
  >
    <ol class="breadcrumbs__list">
      <li
        v-if="showHomeLink && !hasTier2Link"
        class="breadcrumbs__list-item text-body-s-regular"
      >
        <a
          class="breadcrumbs__link"
          :href="$variable('routes.root')"
          v-text="$string('general.breadcrumbs.home')"
        />
      </li>

      <li
        v-if="hasTier2Link"
        class="breadcrumbs__list-item text-body-s-regular"
      >
        <a
          class="breadcrumbs__link"
          :href="$localizeUrl(links.tier2.url)"
          v-text="links.tier2.title"
        />
      </li>

      <li
        v-if="hasTier3Link"
        class="breadcrumbs__list-item text-body-s-regular"
      >
        <a
          class="breadcrumbs__link text-body-s-regular"
          :href="$localizeUrl(links.tier3.url)"
          v-text="links.tier3.title"
        />
      </li>
    </ol>
  </nav>
</template>

<script>

/**
 * Vue: Breadcrumbs (breadcrumbs)
 * -----------------------------------------------------------------------------
 * Site breadcrumb navigation links.
 *
 * @param {Object} links - Tier 2 and 3 breadcrumb links.
 * @param {Boolean} showHomeLink - Display home link in breadcrumbs.
 */
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Breadcrumbs',

  props: {
    links: {
      type: [Boolean, Object],
      default: () => ({
        tier2: {
          title: null,
          url: null,
        },
        tier3: {
          title: null,
          url: null,
        },
      }),
    },
    showHomeLink: {
      type: Boolean,
      default: true,
    },
  },

  computed: {

    /**
     * Compute if has tier2 link.
     */
    hasTier2Link() {
      return this.links.tier2?.title && this.links.tier2?.url
    },

    /**
     * Compute if has tier3 link.
     */
    hasTier3Link() {
      return this.links.tier3.title && this.links.tier3.url
    },
  },
}
</script>

<style lang="scss">
@import './breadcrumbs';
</style>
